"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _dateLabel = _interopRequireDefault(require("./date-label"));
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(_dateLabel["default"]);
exports["default"] = _default;